// extracted by mini-css-extract-plugin
export var hideEditor = "_sb-2";
export var infoIcon = "_sb-3";
export var label = "_sb-1";
export var labelContainer = "_sb-0";
export var readonlyText = "_sb-4";